module.exports = __webpack_public_path__ + "img/08-STATIONARY.png";